import React from "react";

import HoverText from "modules/documents/components/action-buttons/hoverText";
import { NotificationEvents, TenantNotificationSettings } from "modules/messaging";
import { lcidMappings, smsBodiesResource, SMSMappings } from "modules/resources";
import SmsEditor from "modules/sms/smsEditor";
import { eventUppercase } from "utils/notificationsHelper";

import "../components/messaging/messagingSMSControls.sass";

interface ISMSVerifyEditorSectionProps {
    notificationSettings: TenantNotificationSettings;
    smsBodies: smsBodiesResource;
    isSaving: boolean;
    defaultLCID: string;

    setOptInOpen: (open: boolean) => void;
    setSMSBody: (event: string, content: lcidMappings | SMSMappings) => void;
}

const SMSVerifyEditorSection: React.FC<ISMSVerifyEditorSectionProps> = ({
    notificationSettings,
    smsBodies,
    defaultLCID,
    isSaving,
    setSMSBody,
    setOptInOpen
}) => {

    const getInitialTextLength = (plaintext: string) => {
        return plaintext?.replaceAll("\n", ' ').length ?? 0;
    }

    const encodePlaintextAndHtmlIntoLanguageObjects = (plainText: string, html: string): SMSMappings => {
        if(plainText === "" && html === "") {
            return {};
        }

        return {[defaultLCID]: plainText, "html": html}; //We treat HTML as a language!
    }

    const updateSMSTranslations = (event: NotificationEvents, plainText: string, html: string) => {
        const translatedContent = encodePlaintextAndHtmlIntoLanguageObjects(plainText, html);
        setSMSBody(event, translatedContent);
    }

    const getEditorDisclaimer = () => {
        return (
            <div style={{display: "flex", flexDirection: "row"}}>
                Default message will be used if left blank.&nbsp;
                <HoverText label={
                    <>
                        <span onClick={() => setOptInOpen(true)} style={{cursor: "pointer", color: "#3b78ab"}} id="one-time-send-sms-consent">
                            You can also send a one time message.
                        </span>
                    </>
                }>
                    Send a one-time SMS opt-in invitation to specific audiences. This is useful for inviting existing audiences without enabling automatic invites for new users.
                </HoverText>
            </div>
        );
    }

    const initialTextLength = getInitialTextLength(notificationSettings.settings[NotificationEvents.VerifySMSPhone].translatedBody[defaultLCID]);

    return (
        <div className="sms-section" style={{display: "block"}}>
            <div className="sms-editor-header">
                <div>
                    <b>SMS Opt-In Invite Content</b>   
                    <p className="description-text">Customize the text of the SMS opt-in invitation</p>
                </div>
            </div>

            <SmsEditor 
                placeholder={smsBodies[eventUppercase(NotificationEvents.VerifySMSPhone)].toString()}
                maxTextLength={500}
                initialTextLength={initialTextLength}
                onChange={(plaintext, html) => updateSMSTranslations(NotificationEvents.VerifySMSPhone, plaintext, html)}
                value={notificationSettings.settings[NotificationEvents.VerifySMSPhone].translatedBody["html"] ?? notificationSettings.settings[NotificationEvents.VerifySMSPhone].translatedBody[defaultLCID]}
                disclaimer={getEditorDisclaimer()}
                id={"verify-sms-phone-editor"}
                disabled={isSaving}
                useExternalEditorRef={false}
            />
            
        </div>
    );
}

export default SMSVerifyEditorSection;